import { z } from 'zod';

const emailSchema = z.email();

export const isEmailValid = (email: string): boolean => emailSchema.safeParse(email).success;
